<template>

          <v-layout>

			<v-flex xs12>

				<isotope ref="cpt" :list="list" id="root_isotope" :options='isotope_options' v-images-loaded:on.progress="layout" >


					<div class="element-item" v-for="(item, index) in list"  :key="item.id" >
						<app-inmobiliaria-widget :item="item"></app-inmobiliaria-widget>

					</div>


				 </isotope>
				 <infinite-loading :on-infinite="onInfinite" :distance=500 ref="InfiniteLoading" spinner="spiral">
	 			  <span slot="no-more"></span>
	 			</infinite-loading>


		   </v-flex>

          </v-layout>
</template>

<style>


/* Custom, iPhone Retina */
@media only screen and (min-width : 320px) {
	.element-item{
		width:100%;
		/*border:1px solid #ff0000;*/
	}
}
/* Extra Small Devices, Phones */
@media only screen and (min-width : 480px) {
	.element-item{
		width:100%;
		/*border:1px solid #ff0000;*/
	}
}
/* Small Devices, Tablets */
@media only screen and (min-width : 768px) {
	.element-item{
		width:50%;
		/*border:1px solid #ff0000;*/
	}
}
/* Medium Devices, Desktops */
@media only screen and (min-width : 992px) {
	.element-item{
		width:33%;
		/*border:1px solid #ff0000;*/
	}
}
/* Large Devices, Wide Screens */
@media only screen and (min-width : 1200px) {
	.element-item{
		width:25%;
		/*border:1px solid #ff0000;*/
	}
}
.element-item{
	padding:0 10px 20px 10px;
	float:left;
	/*border:1px solid #ff0000;*/
}
.element-item v-card{
	padding:10px;
}
.card-item{
	padding:10px;
}
</style>
<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import Isotope from 'vueisotope'
  import ImagesLoaded from 'vue-images-loaded'
  import AppInmobiliariaWidget from '@/components/AppInmobiliariaWidget'
  import axios from 'axios';
  export default {
    data () {
      return {
		drawer: false,
		// -
		list: [],
	    page: 0,
	    per_page: null,
	    total: null,
	    last_page: 99,
	    // -isotope
		selected: null,
	    isotope_options: {
		  itemSelector: '.element-item',
    	  layoutMode: 'masonry',
		  transitionDuration: 0,
		  masonry: {
		    gutterWidth: 10
		  }
	    }
      }
    },
	head: {
	  title: {
		inner: 'Inmobiliarias',
		//separator: '-',
		complement: '9dejulio.com'
	  },
	  //omited
	},
	components: {
      InfiniteLoading,
	  Isotope,
	  AppInmobiliariaWidget
    },
	directives: {
		ImagesLoaded
	},
	methods: {
		fetchData () {
			//console.log('fetchdata');
	        this.page++
	        axios.get(this.$apiUrl + 'empresa', {
	          params: {
	            page: this.page,
	          }
	        }).then(response => {
	          if (response.data.items.length) {
	            // ??????????????
	            for (var i = 0; i < response.data.items.length; i++) {
	              var f = false
	              for (var ii = 0; ii < this.list.length; ii++) {
	                if (this.list[ii].id === response.data.items[i].id) {
	                  f = true
	                }
	              }
	              if (!f) {
	                this.list.push(response.data.items[i])
	              }
	            }
	            // ??????????????
	            this.$refs.InfiniteLoading.$emit('$InfiniteLoading:loaded')
	            if (response.data.last_page === this.page) {
	              this.$refs.InfiniteLoading.$emit('$InfiniteLoading:complete')
	            }
	          } else {
	            this.$refs.InfiniteLoading.$emit('$InfiniteLoading:complete')
	          }
	        }).bind(this)
	},

   layout: function () {
	 this.$refs.cpt.layout('masonry')
   },
   onInfinite: function () {
	 this.fetchData()
   }
 }

  }
</script>



// WEBPACK FOOTER //
// AppInmobiliaria.vue?7ca22218